import { Autocomplete, Chip, Grid2, TextField, Typography } from "@mui/material";
import { CateringTableRow } from "./CateringTableRow.types";
import { t } from "i18next";
import { CompanyUnits } from "../../../../../../../hooks/Remote/CompanyUnits/useRemoteFetchCompanyUnits";
import { useTranslation } from "react-i18next";

/** display Catering Image */
export const renderCateringServiceQuantity = (params: CateringTableRow) => {
  return (
    <TextField
      type="number"
      id="catering-qty"
      label={t("Qty")}
      value={params.qty}
      data-testid="catering-service-quantity-field"
      // onChange={e => (original.qty = Number(e.target.value))}
    />
  );
};

type SelectCostCenterProps = {
  isMobile: boolean;
  isEditable: boolean;
  isCostExisting: boolean;
  remoteDepartments: CompanyUnits[] | undefined;
  cateringData: { qty: number; pricePerUnit?: number }[];
  selectCostCenter?: { id: string; name: string } | null;
  handleChangeCostCenter: (
    event: React.SyntheticEvent,
    value: { id: string; name: string } | null
  ) => void;
};

/** render service catering item selecting cost center part */
export function CateringServiceSelectCostCenter({
  isMobile,
  isEditable,
  isCostExisting,
  remoteDepartments,
  cateringData,
  selectCostCenter,
  handleChangeCostCenter
}: Readonly<SelectCostCenterProps>) {
  const { t } = useTranslation();

  return (
    <Grid2
      sx={[
        { display: "flex", justifyContent: "flex-end", alignItems: "center" },
        isMobile ? { flexDirection: "column" } : { flexDirection: "row" },
        isMobile ? { textAlign: "end" } : { textAlign: "inherit" }
      ]}
    >
      {isEditable && (
        <Autocomplete
          options={remoteDepartments ?? []}
          noOptionsText={t("No Departments available")}
          defaultValue={selectCostCenter}
          getOptionLabel={option => option.name}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onChange={handleChangeCostCenter}
          renderOption={(props, option) => (
            <li {...props}>
              <div data-testid="department-option">{option.name}</div>
            </li>
          )}
          renderInput={params => (
            <TextField
              {...params}
              fullWidth
              data-testid={"bookingService-department-field"}
              placeholder={t("Select cost center")}
              sx={{ minWidth: "200px" }} // disabled={isEditable}
            />
          )}
          renderTags={(tagValue, getTagProps) => {
            return tagValue.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={option.id}
                data-testid={`${option.id}-select-chip`}
                label={option.name}
              />
            ));
          }}
        />
      )}
      {isCostExisting && (
        <Typography sx={{ ml: 2, pt: 0.5, minWidth: "150px" }}>
          {`${t("_bookingServiceCateringTotalPrice")}: `}
          {cateringData
            .reduce((total, item) => {
              return total + item.qty * (item.pricePerUnit ?? 0);
            }, 0)
            .toFixed(2)}
        </Typography>
      )}
    </Grid2>
  );
}
